import React from 'react';
import styles from './customTextArea.module.scss';
import { Form } from 'react-bootstrap';

export const CustomTextArea = (props) => {
    return (
        <div id={props.id}>
            <Form.Group controlId={props.controlId}>
                {props.label &&
                    <Form.Label className={styles.textareaLabel}>{props.label} {props.showDefaultErrorMsg ? <span className={styles.defaultErrorMsg}>{props.defaultErrorMsg}</span> : ''}</Form.Label>
                }
                <Form.Control as="textarea" name={props.name} value={props.values} onChange={props.handleChange} rows={3} className={styles.textareaBox} isInvalid={props.isInvalid} maxLength={props.maxLength} placeholder={props.placeholder} disabled={props.disabled}/>
                {props.maxLength &&
                    <Form.Text className={styles.remainingCount}><b>{props.remainingCount}</b>/{props.maxLength}</Form.Text>
                }
                {props.errorMessage &&
                    <Form.Control.Feedback type="invalid" key={(props.keyValue) + 2} id={props.validationMessageId} className={`${styles.errorDiv} ${styles.errorMsg}`}>
                        {props.errorMessage}
                    </Form.Control.Feedback>
                }

            </Form.Group>
        </div>
    )
}
